<template>
  <div style="height:100%" class="attr">
    <div class="manage" v-if="showAttr == false && showEdit == false">
      <div class="content">
        <div class="operation">
          <el-button
            type="primary"
            :round="false"
            size="small"
            icon="el-icon-plus"
            @click="showAttr = true"
          >
            <span>添加</span>
          </el-button>
          <!-- <span style="margin-left:20px;">品牌名称：</span>
          <el-input
            v-model="screenValue"
            placeholder="新品牌"
            size="small"
            style="width:200px;margin-right:5px;"
          ></el-input>
          <el-button
            type="primary"
            :round="false"
            size="small"
            icon="el-icon-search"
            @click="screen"
          >
            <span>筛选</span>
          </el-button>-->
        </div>
        <div class="AttrList">
          <template>
            <el-table
              :border="true"
              :data="tableData"
            >
              <el-table-column type="index"></el-table-column>
              <el-table-column
                prop="name"
                label="名称"
                width="180"
              ></el-table-column>
              <el-table-column label="属性值" width="180">
                <template slot-scope="scope">
                  <span
                    v-for="(item, index) in scope.row.SpecValue"
                    :key="index"
                    >{{ item.value }}&nbsp;|&nbsp;</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="sort"
                label="排序"
                width="180"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="Otherpage">
          <div class="changePage">
            <div @click="upPage" class="btnColor">
              <span>上一页</span>
            </div>
            <div>
              <span>{{ page }}</span>
            </div>
            <div @click="downPage" class="btnColor">
              <span>下一页</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <addAttr @closeAttr="closeadd" v-show="showAttr"></addAttr>
    <editAttr @close="closeEdit" v-show="showEdit" :row="newRow"></editAttr>
  </div>
</template>

<script>
import addAttr from "@/components/commodity/addAttr.vue";
import editAttr from "@/components/commodity/editAttr.vue";
import { AttrList, delAttr } from "@/api/mall";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {
    addAttr,
    editAttr
  },
  data() {
    return {
      screenValue: "",
      newRow: {},
      showEdit: false,
      showAttr: false,
      idx: 1,
      nowIDx: 0,
      value: "",
      input: "",
      page: "1",
      tableData: []
    };
  },
  // watch: {
  //   screenValue() {
  //     if (this.screenValue == "") {
  //       this.getAttrlist();
  //     }
  //   }
  // },
  methods: {
    // 关闭页面
    closeadd(item) {
      this.showAttr = item;
      this.getAttrlist();
    },
    closeEdit(item) {
      this.showEdit = item;
      this.getAttrlist();
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.showEdit = true;
      this.newRow = row;
    },
    // 删除
    handleDelete(index, row) {
      console.log(index, row);
      let data = {
        token: this.token,
        id: row.id
      };
      delAttr(data).then(res => {
        console.log(res);
        this.getAttrlist();
      });
    },
    // 属性列表
    getAttrlist() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        page: this.page
      };
      AttrList(data).then(res => {
        console.log(res);
        this.tableData = res.data;
      });
    },
    // 筛选
    // screen() {
    //   if (this.screenValue == "") {
    //     this.$message("输入不许为空");
    //   } else {
    //     console.log(111);
    //     let data = {
    //       token: this.token,
    //       app_id: this.app_id,
    //       merch_id: this.merch_id,
    //       page: "1",
    //       name: this.screenValue
    //     };
    //     AttrList(data).then(res => {
    //       console.log(res);
    //       this.tableData = res.data;
    //     });
    //   }
    // },
    upPage() {
      // 上一页
      this.page--;
      if (this.page == 0) {
        this.page = 1;
        this.getAttrlist();
      } else {
        this.getAttrlist();
      }
    },
    downPage() {
      // 下
      this.page++;
      console.log(this.page);
      this.getAttrlist();
      console.log(this.tableData.length);
      if (this.tableData.length == 0) {
        this.$message("请添加新品牌");
        this.page--;
        this.getAttrlist();
      }
    }
  },
  mounted() {
    this.getAttrlist();
  }
};
</script>

<style lang="scss" scoped>
el-table {
  height: calc(100% - 20px);
}
.manage {
  height: 100%;
  padding-left: 22px;
  padding-right: 72px;
  position: relative;
  .content {
    overflow: hidden;
    position: absolute;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 30px;
    .operation {
      height: 36px;
    }
    .AttrList {
      height: 100%;
      margin-top: 20px;
    }
    .Otherpage {
      height: 34px;
      width: 200px;
      position: absolute;
      bottom: 0;
      left: 30px;
      .changePage {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        div {
          height: 100%;
          width: 30%;
          text-align: center;
          line-height: 34px;
        }
        .btnColor {
          background: #b0b5bb30;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.attr {
  .manage {
    .cell {
      text-align: left;
    }
  }
}
</style>
